import React, { useRef, useState, useEffect } from 'react';
import { useIntersection } from '../hooks/useScrolled';
import banner1 from '../images/3.jpg';
import banner2 from '../images/4.jpg';
import './HeroSection.css';

export default function HeroSection() {
  const ref = useRef(null);
  const visible = useIntersection(ref);

  const slides = [banner1, banner2];

  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  // Auto slide
  useEffect(() => {
    if (paused) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000); // 4 sec

    return () => clearInterval(interval);
  }, [paused, slides.length]);

  return (
    <section
      className="hero"
      id="home"
      ref={ref}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* Background */}
      <div className="hero__bg-layer hero__bg-left" />
      <div className="hero__bg-layer hero__bg-center" />

      {/* Image Slider */}
      <div className="hero__image-container">
        {slides.map((img, index) => (
          <img
            key={index}
            src={img}
            alt="Jewellery banner"
            className={`hero__woman-img ${
              index === current ? 'active' : ''
            }`}
          />
        ))}
        <div className="hero__image-overlay" />
      </div>

      {/* Content */}
      <div className={`hero__content${visible ? ' visible' : ''}`}>
        <p className="hero__tag">Welcome to JKS Jewels</p>

        <h1 className="hero__headline">
          Luxury Jewelry<br />
          Collections<br />
          Designed to Upgrade <br />
          Your Style.
        </h1>

        <p className="hero__subtext">
          At JKS Jewels Pvt Ltd,  every sparkle is a promise of quality, trust, and timeless elegance.
        </p>

        <a href="#jewellery" className="hero__cta">
          explore collections
        </a>

        {/* Dots */}
        <div className="hero__dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`hero__dot ${
                index === current ? 'hero__dot--active' : ''
              }`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}